import React, { useState, useEffect } from "react";
import MyCircleList from "./my_circle_list";
import axios from "../axios";

const Profile = ({ userId, companyId, companyIdToParam }) => {
  // const [userfeeds, setUserFeeds] = useState([]);
  const [usersCircles, setUsersCircles] = useState([]);
  // const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  // const [isLastPage, setIsLastPage] = useState(false);
  // const [page, setPage] = useState(1);

  // スクロール時
  // const loadNextList = useCallback(
  //   () => {
  //     if (isLoadingNextList || isLastPage) {
  //       return;
  //     }
  //     setIsLoadingNextList(true);
  //     axios.get(`/api/userfeeds/users/${userId}?page=${page}`).then((res) => {
  //       setUserFeeds([...userfeeds, ...res.data.userfeeds]);
  //       setPage(page + 1);
  //       setIsLoadingNextList(false);
  //       setIsLastPage(res.data.isLastPage);
  //       if (res.data.userfeeds.length === 0) {
  //         setIsLastPage(true);
  //       }
  //     });
  //   },
  //   [isLoadingNextList, isLastPage, setIsLoadingNextList]
  // );

  useEffect(() => {
    // axios.get(`/api/userfeeds/users/${userId}?page=${page}`).then((res) => {
    //   setUserFeeds(res.data.userfeeds);
    // });
    if (companyId === undefined) {  // iconが渡されていない場合
      axios.get(`/api/member/profile/${userId}`).then((res) => {
        setUsersCircles(res.data.usersCircles);
      });
    } else {
      axios.get(`/api/member/profile/${userId}?company_id=${companyId}`).then((res) => {
        setUsersCircles(res.data.usersCircles);
      });
    }
  }, []);

  if (!usersCircles.length) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="container col-md-8 col-lg-6">
        <h2 className="mp-block-title">参加サークル</h2>
      </div>
      <MyCircleList
        usersCircles={usersCircles}
        companyIdToParam={companyIdToParam}
      />
    </React.Fragment>
  );
};

export default Profile;
